import React, { useRef, useEffect, useState } from "react";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import {
  Physics,
  usePlane,
  useCompoundBody,
  useSphere,
  Debug,
  useBox,
} from "@react-three/cannon";
import { Environment, OrbitControls } from "@react-three/drei";
import * as THREE from "three";
// import { MazeModel } from "../models/Maze";
import { MazeModel } from "../models/Maze_Two";

const MazeCircular = () => {
  function Plane(props) {

    return (
      <mesh rotation= {[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
        <planeGeometry args={[40, 40]} />
        <meshStandardMaterial side={THREE.DoubleSide} metalness={1} roughness={2} color="brown" />
      </mesh>
    );
  }

  const usePersonControls = () => {
    const keys = {
      KeyW: "forward",
      KeyS: "backward",
      KeyA: "left",
      KeyD: "right",
      Space: "jump",
    };

    const moveFieldByKey = (key) => keys[key];

    const [movement, setMovement] = useState({
      forward: false,
      backward: false,
      left: false,
      right: false,
      jump: false,
    });

    useEffect(() => {
      const handleKeyDown = (e) => {
        setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: true }));
      };
      const handleKeyUp = (e) => {
        setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: false }));
      };
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("keyup", handleKeyUp);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("keyup", handleKeyUp);
      };
    }, []);
    return movement;
  };

  function Sphere(props) {
    const [ref, api] = useSphere(() => ({
      linearDamping: 0.5, // Add damping to slow the ball down a bit
      allowSleep: false, // Don't let the ball "sleep"
      ccdSpeedThreshold: 1, // Enable CCD at this speed
      ccdSweptSphereRadius: 0.25, // Radius for CCD testing
      args: [0.015],
      mass: 0.1,
      position: [0, 0.1, 0],
      friction: 1, // Reduce friction for the sphere
      restitution: 0,
      ...props,
    }));
    const movement = usePersonControls();
    const speed = 5; // Adjust speed as necessary
    const damping = 0.05; // Damping factor for smoothness
    const [velocity, setVelocity] = useState(new THREE.Vector3(0, 0, 0));

    // useFrame(() => {
    //   let frontVector = new THREE.Vector3(0, 0, 0);
    //   let sideVector = new THREE.Vector3(0, 0, 0);
    //   let direction = new THREE.Vector3(0, 0, 0);

    //   frontVector.set(0, 0, Number(movement.forward) - Number(movement.backward));
    //   sideVector.set(Number(movement.right) - Number(movement.left), 0, 0);
    //   direction
    //     .subVectors(frontVector, sideVector)
    //     .normalize()
    //     .multiplyScalar(20);

    //   // Update velocity with damping
    //   const newVelocity = velocity.clone().lerp(direction, damping);
    //   setVelocity(newVelocity);
    //   api.velocity.set(-newVelocity.x, 0, -newVelocity.z); // Set the new velocity
    //   if (movement.jump) {
    //     api.velocity.set(-newVelocity.x, speed, -newVelocity.z); // Apply an upward force for jumping
    //   }
    // });

    return (
      <mesh ref={ref}>
        <sphereGeometry args={[0.02]} />
        <meshStandardMaterial color={"yellow"} roughness={0.2} metalness={2} />
      </mesh>
    );
  }

  function Wall({ position, rotation, ...props }) {
    return (
      <mesh position={position} rotation={rotation} {...props}>
        <boxGeometry args={[41.5, 3, 1.5, 8, 4, 2]} />
        <meshStandardMaterial side={THREE.DoubleSide} color="black" />
      </mesh>
    );
  }

  function InnerWall({ position, rotation, ...props }) {
    return (
      <mesh position={position} rotation={rotation} {...props}>
        <boxGeometry args={[20, 3, 1.5, 8, 4, 2]} />
        <meshBasicMaterial side={THREE.DoubleSide} color="darkBrown" />
      </mesh>
    );
  }

  function Base(props) {
    // Create a compound body with all walls as shapes
    const [ref, api] = useCompoundBody(() => ({
      mass: 0, // mass: 0 makes it static
      type: "Static",
      shapes: [
        {type: "Plane", mass: 0, friction: 0.1, position:[0, 0, 0], args:[40,40], rotation: [-Math.PI / 2, 0, 0],},
        // North wall
        { type: "Box", position: [0, 1, -20], args: [40, 5, 0.5] },
        // South wall
        { type: "Box", position: [0, 1, 20], args: [40, 5, 0.5] },
        // East wall - rotation handled by adjusting the box dimensions and position
        {
          type: "Box",
          position: [20, 1, 0],
          args: [0.5, 5, 40],
          rotation: [0, 0, 0],
        },
        // West wall
        {
          type: "Box",
          position: [-20, 1, 0],
          args: [0.5, 5, 40],
          rotation: [0, 0, 0],
        },
      ],
      ...props,
    }));

    const { pointer } = useThree();

   // Add these at the top with your other state variables
const [currentRotation, setCurrentRotation] = useState(0);

const [currentRotationX, setCurrentRotationX] = useState(0);
const [currentRotationZ, setCurrentRotationZ] = useState(0);

useFrame((state, delta) => {
    if (ref.current) {
      // Get distance from center
      const distance = Math.sqrt(
        pointer.x * pointer.x + pointer.y * pointer.y
      );
  
      // Calculate angle based on mouse position
      const angleY = pointer.y; // For x-axis rotation (up/down)
      const angleX = pointer.x; // For z-axis rotation (left/right)
  
      // Scale rotation by distance from center for more intuitive control
      // With a much lower maximum speed
      const rotationFactor = Math.min(distance * 1, 1); // Lower maximum value
      const targetRotationX = -angleY * rotationFactor; // Up/down movement affects x-axis
      const targetRotationZ = -angleX * rotationFactor; // Left/right movement affects z-axis (negative for natural direction)
      
      // Interpolate between current and target rotation (smoother transition)
      // The lower the interpolation factor, the smoother but slower the rotation
      const interpolationFactor = Math.min(delta * 3, 0.1); // Adjust this value as needed
      
      // Track both x and z rotations separately
      const newRotationX = currentRotationX + (targetRotationX - currentRotationX) * interpolationFactor;
      const newRotationZ = currentRotationZ + (targetRotationZ - currentRotationZ) * interpolationFactor;
      
      // Update the rotation states
      setCurrentRotationX(newRotationX);
      setCurrentRotationZ(newRotationZ);
      
      // Apply rotation to the compound body
      ref.current.rotation.x = newRotationX;
      ref.current.rotation.z = newRotationZ;
      
      // Apply to physics api if you're using react-three/cannon
      api.rotation.set(newRotationX, 0, newRotationZ);
    }
  });

    // useFrame(() => {
    //   if (ref.current) {
    //     // Calculate rotation based on mouse position
    //     const targetRotationX = pointer.x * 1;

    //     // Apply rotation to the entire compound body
    //     ref.current.rotation.y = targetRotationX;
    //     api.rotation.set(0, targetRotationX, 0);
    //   }
    // });

    return (
      <group ref={ref}>
        <Plane />
        <Wall position={[0, 1, -20]} />
        <Wall position={[0, 1, 20]} />
        
        {/* <InnerWall position={[2,1,-10]} rotation={[0, Math.PI / 2, 0]} /> */}

        <Wall position={[20, 1, 0]} rotation={[0, Math.PI / 2, 0]} />
        <Wall position={[-20, 1, 0]} rotation={[0, Math.PI / 2, 0]} />
      </group>
    );
  }

  const Floor = (props) => {
    // apply the size same as the geometry
    const [ref, api] = useBox(() => ({ args: [20, 0.1, 10] }));
    return (
      <mesh ref={ref} receiveShadow {...props}>
        <boxGeometry args={[20, 0.1, 10]} />
        <meshStandardMaterial color="white" />
      </mesh>
    );
  };

  let camera = new THREE.PerspectiveCamera(90, 2, 0.1, 1000);
  let [x, y, z] = [0, 0.8, 0];
  let [rotateX, rotateY, rotateZ] = [0, 0, 0];
  camera.position.set(x, y, z);
  camera.rotation.set(rotateX, rotateY, rotateZ);
  return (
    <div className="w-screen h-screen bg-slate-800">
      <Canvas camera={camera}>
        {/* <ambientLight intensity={0.1} /> */}
        {/* <pointLight position={[0, 3, 0]} /> */}
        {/* <directionalLight intensity={2} position={[0,15,30]} rotation={[THREE.MathUtils.degToRad(-30), 0, 0]} color={"white"} /> */}
        <Environment preset="forest" />
        <Physics
          defaultContactMaterial={{ restitution: 0.1 }}
          iterations={8} // Increase from default
          allowSleep={false}
          gravity={[0, -1, 1]}
        >
          {/* <Debug> */}
            <Sphere />
            {/* <Base /> */}
            <MazeModel />
            {/* <Floor /> */}
          {/* </Debug> */}
        </Physics>
        {/* <OrbitControls /> */}
      </Canvas>
    </div>
  );
};

export default MazeCircular;
